import styled from '@emotion/styled';

export const FieldContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  svg {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

export const FormFieldLabel = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
`;

export const PcfraStatusComments = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  em {
    ${({ theme }) => theme.text.body2};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;
